
export default {
  defaultCredentials: {
    username: '',
    password: '',
  },
  apiPath: 'http://localhost:4007/api/v1',
};
